module.exports = __webpack_public_path__ + "img/banescard.a6953f1c.png";